import { useEffect } from "react";

export default function WindowRedirect({ url }: { url: string }) {
    useEffect(() => {
        // Browser redirect
        window.location.href = url;
    }, []);

    return null; // nothing rendered
}